<div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start end" fxFlex.gt-sm="100">
    <div class="widget" id="doctor-filter"  fxFlex.gt-sm="100">
      <mat-form-field>
        <mat-label>Derivar todas las tareas al/la gestionador/a</mat-label>
        <mat-select class="full-width-multi-select width-378" [formControl]="FormElement">
          <mat-option *ngFor="let user of UserList$" [value]="user.value">{{user.viewValue}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>